function mdpEscapeHtml(str) {
  if (!str) return '';
  var div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

function mdpRenderStars(rating) {
  var full = Math.round(rating || 0);
  var out = '';
  for (var i = 0; i < 5; i++) {
    out += i < full ? '★' : '☆';
  }
  return out;
}

function mdpBuildReviewCard(r) {
  return (
    '<div class="mdp-review-card">' +
    '<div class="mdp-review-stars">' +
    mdpRenderStars(r.rating) +
    '</div>' +
    '<p class="mdp-review-text">' +
    mdpEscapeHtml(r.text) +
    '</p>' +
    '<div class="mdp-review-author">' +
    (r.profile_photo_url
      ? '<img src="' + r.profile_photo_url + '" alt="" class="mdp-review-avatar" loading="lazy">'
      : '') +
    '<span>' +
    mdpEscapeHtml(r.author_name) +
    '</span>' +
    '</div>' +
    '</div>'
  );
}

function mdpInitCarousel(root) {
  var track = root.querySelector('.mdp-carousel-track');
  var slides = Array.prototype.slice.call(root.querySelectorAll('.mdp-carousel-slide'));
  var prevBtn = root.querySelector('.mdp-carousel-prev');
  var nextBtn = root.querySelector('.mdp-carousel-next');
  var dotsWrap = root.querySelector('.mdp-carousel-dots');
  var autoplay = root.getAttribute('data-autoplay') === 'true';
  var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
  var index = 0;
  var timer = null;

  if (slides.length <= 1) {
    if (prevBtn) prevBtn.style.display = 'none';
    if (nextBtn) nextBtn.style.display = 'none';
    return;
  }

  slides.forEach(function (slide, i) {
    var dot = document.createElement('button');
    dot.className = 'mdp-carousel-dot' + (i === 0 ? ' is-active' : '');
    dot.type = 'button';
    dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
    dot.addEventListener('click', function () {
      goTo(i);
      resetAutoplay();
    });
    dotsWrap.appendChild(dot);
  });

  var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.mdp-carousel-dot'));

  function update() {
    track.style.transform = 'translateX(-' + index * 100 + '%)';
    dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i === index);
    });
  }

  function goTo(i) {
    index = (i + slides.length) % slides.length;
    update();
  }

  function next() {
    goTo(index + 1);
  }

  function prev() {
    goTo(index - 1);
  }

  function resetAutoplay() {
    if (!autoplay) return;
    if (timer) clearInterval(timer);
    timer = setInterval(next, interval);
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      next();
      resetAutoplay();
    });
  }
  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      prev();
      resetAutoplay();
    });
  }

  // basic swipe support
  var startX = null;
  track.addEventListener(
    'touchstart',
    function (e) {
      startX = e.touches[0].clientX;
    },
    { passive: true }
  );
  track.addEventListener(
    'touchend',
    function (e) {
      if (startX === null) return;
      var diff = e.changedTouches[0].clientX - startX;
      if (diff > 40) {
        prev();
        resetAutoplay();
      } else if (diff < -40) {
        next();
        resetAutoplay();
      }
      startX = null;
    },
    { passive: true }
  );

  update();
  resetAutoplay();
}

function initMdpGoogleReviews() {
  var containers = document.querySelectorAll('[data-mdp-google-reviews]');

  containers.forEach(function (container) {
    var placeId = container.getAttribute('data-place-id');
    var maxReviews = parseInt(container.getAttribute('data-max-reviews'), 10) || 5;
    var minRating = parseInt(container.getAttribute('data-min-rating'), 10) || 0;

    if (!placeId) {
      container.innerHTML =
        '<div class="mdp-empty-state"><strong>No Google Place ID set.</strong> Add one in the theme editor.</div>';
      return;
    }

    if (typeof google === 'undefined' || !google.maps || !google.maps.places) {
      container.innerHTML =
        '<div class="mdp-empty-state"><strong>Could not load Google Maps.</strong> Check that your API key is valid and that "Maps JavaScript API" + "Places API (New)" are enabled in Google Cloud Console.</div>';
      return;
    }

    var mapDiv = document.createElement('div');
    var service = new google.maps.places.PlacesService(mapDiv);

    service.getDetails(
      {
        placeId: placeId,
        fields: ['reviews', 'rating', 'user_ratings_total', 'name', 'url'],
      },
      function (place, status) {
        if (status !== google.maps.places.PlacesServiceStatus.OK || !place) {
          container.innerHTML =
            '<div class="mdp-empty-state"><strong>Could not load reviews.</strong> Check your API key and Place ID in the theme editor.</div>';
          return;
        }

        var reviews = (place.reviews || [])
          .filter(function (r) {
            return (r.rating || 0) >= minRating;
          })
          .slice(0, maxReviews);

        if (reviews.length === 0) {
          container.innerHTML = '<div class="mdp-empty-state">No reviews to display yet.</div>';
          return;
        }

        var slidesHtml = reviews
          .map(function (r) {
            return '<div class="mdp-carousel-slide">' + mdpBuildReviewCard(r) + '</div>';
          })
          .join('');

        var html =
          '<div class="mdp-carousel">' +
          '<button type="button" class="mdp-carousel-arrow mdp-carousel-prev" aria-label="Previous review">‹</button>' +
          '<div class="mdp-carousel-viewport">' +
          '<div class="mdp-carousel-track">' +
          slidesHtml +
          '</div>' +
          '</div>' +
          '<button type="button" class="mdp-carousel-arrow mdp-carousel-next" aria-label="Next review">›</button>' +
          '</div>' +
          '<div class="mdp-carousel-dots"></div>';

        html +=
          '<div class="mdp-attribution"><a href="' +
          (place.url || '#') +
          '" target="_blank" rel="noopener">Reviews via Google' +
          (place.rating ? ' — ' + place.rating + '★ (' + place.user_ratings_total + ')' : '') +
          '</a></div>';

        container.innerHTML = html;
        mdpInitCarousel(container);
      }
    );
  });
}
